module.exports = __webpack_public_path__ + "img/pr-2.f4b6b641.png";